/* Coordinate existing bottom controls from actual overlay state, not ARIA labels. */
(function (w, d) {
  'use strict';
  if (w.__bmOverlayState) return;
  w.__bmOverlayState = true;
  var pending = false;
  function update() {
    pending = false;
    var open = !!d.querySelector('dialog[open]:not([hidden]), [role="dialog"][open]:not([hidden]), .drawer[open]:not([hidden])');
    d.documentElement.classList.toggle('bm-overlay-open', open);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    w.requestAnimationFrame(update);
  }
  ['toggle', 'drawer:afterShow', 'drawer:afterHide', 'modal:afterShow', 'modal:afterHide', 'shopify:section:load', 'shopify:section:unload'].forEach(function (name) {
    d.addEventListener(name, schedule, true);
  });
  w.addEventListener('pageshow', schedule);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})(window, document);
